const version = 'v1.7';
export default version;
